import { spotifyDiscoveryConstants } from '../constants/spotify_discovery';

export function spotifyDiscovery(state = {data: undefined, totals: undefined, timeseries: undefined, dates: {}}, action) {
	switch (action.type) {
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_REQUEST:
			return {
				...state,
				loading: true,
				data: undefined
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.data
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error
			};
	
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TOTALS_REQUEST:
			return {
				...state,
				loadingTotals: true,
				totals: undefined
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TOTALS_SUCCESS:
			return {
				...state,
				loadingTotals: false,
				totals: action.data
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TOTALS_FAILURE:
			return {
				...state,
				loadingTotals: false,
				error: action.error
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TIMESERIES_REQUEST:
			return {
				...state,
				loadingTimeseries: true,
				timeseries: undefined

			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TIMESERIES_SUCCESS:
			return {
				...state,
				loadingTimeseries: false,
				timeseries: action.data

			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TIMESERIES_FAILURE:
			return {
				...state,
				loadingTimeseries: false,
				error: action.error
			};
			
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_REQUEST:
			return {
				...state,
				loadingDetails: true,
				details: undefined
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_SUCCESS:
			return {
				...state,
				loadingDetails: false,
				details: action.data

			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_FAILURE:
			return {
				...state,
				loadingDetails: false,
				error: action.error
			};

		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_REQUEST:
			return {
				...state,
				loadingDetailsTimeseries: true,
				detailsTimeseries: null
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_SUCCESS:
			return {
				...state,
				loadingDetailsTimeseries: false,
				detailsTimeseries: action.data
		
			};
		case spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_FAILURE:
			return {
				...state,
				loadingDetailsTimeseries: false,
				error: action.error
			};
			
		case spotifyDiscoveryConstants.RESET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES: 
			return {
			...state,
				loadingDetailsTimeseries: false,
				detailsTimeseries: null
			};
		


		default:
			return state
	}
} 